import request from './base'

export const dealerList = (params) => {
    return request.post("/admin/v1/dealer/list",params)
}

export const dealerModify = (params) => {
    return request.post("/admin/v1/dealer/dealerModify", params)
}

export const disableDealerAccount = (params) => {
    return request.post("/admin/v1/dealer/disableDealerAccount", params)
}


// WEBPACK FOOTER //
// ./src/api/dealer.js